import { ColumnFlexBox, FlexBoxFullWidth } from '../common/boxes';
import React, { useCallback, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { LOGO_PATH, SMALL_LOGO_PATH } from '../../core/variables';
import { MAIN_LINKS, SUPPORT_LINKS } from './types';
import MainLink from './MainLink';
import { useLocation } from 'react-router-dom';
import { sidebarSetup, sidebarSupportSetup } from './useSidebarSetup';
import Logout from './Logout';
import ExpandIcon from '../common/ExpandIcon';
import { useAuthLoggedIn } from '../../+state/useAuthState';
import { useLogout } from '../../queryHooks/auth/useLogout';

// const CustomLi = styled('li')(({ theme, isActive }: { theme?: any, isActive: boolean }) => ({
//   marginLeft: theme.spacing(5),
//   listStyle: isActive ? 'circle' : 'initial',
//   color: isActive ? theme.palette.primary.main : 'initial',
//   [theme.breakpoints.down('laptop')]: {
//     marginLeft: theme.spacing(1)
//   },
//   [theme.breakpoints.down('tablet')]: {
//     marginLeft: theme.spacing(-1)
//   }
// }));

const Sidebar = () => {
  const theme = useTheme();
  const { user } = useAuthLoggedIn();
  const [expanded, setExpanded] = useState(true);
  const { pathname } = useLocation();
  const expandHandler = useCallback(() => setExpanded(prev => !prev), []);
  const logout = useLogout();

  return (
    <ColumnFlexBox borderRight={2} borderColor={theme.palette.grey.A100} justifyContent={'space-between'}
                   sx={{ overflowX: 'hidden' }}>

      {/*LOGO*/}
      <Box px={{ mobile: .5, laptop: 1 }}>
        <Box width={{ mobile: expanded ? 120 : 40, tablet: expanded ? 160 : 40, laptop: expanded ? 200 : 40 }}
             height={{ mobile: 50, tablet: 50 }}
             sx={{
               background: `url("${expanded ? LOGO_PATH : SMALL_LOGO_PATH}")`,
               backgroundRepeat: 'no-repeat',
               backgroundSize: 'contain',
               backgroundPosition: 'center',
             }}
        >
        </Box>
      </Box>

      <FlexBoxFullWidth justifyContent={'flex-end'}>
        <ExpandIcon onClick={expandHandler} expanded={expanded} downDirection={false}/>
      </FlexBoxFullWidth>

      {
        Object.values(MAIN_LINKS).map((name, index) => {
            const option = sidebarSetup[name];
            return (
              <Box key={name}>
                <MainLink
                  expanded={expanded}
                  name={name}
                  path={option.getPath()}
                  icon={option.icon || ''}
                  isWithActiveChild={pathname.startsWith(option.getPath())}
                  isActive={pathname.startsWith(option.getPath())}
                />
                {/*{*/}
                {/*  !!option.subTabs.length && expanded &&*/}
                {/*  <ul style={{ margin: 0 }}>*/}
                {/*    {*/}
                {/*      option.subTabs.map((subOption, i) => {*/}
                {/*          const isActive = pathname.startsWith(option.getPath() + subOption.getPath());*/}
                {/*          return (*/}
                {/*            <CustomLi key={name + subOption.name + i} isActive={isActive}>*/}
                {/*              <Box key={name + subOption.name}>*/}
                {/*                <SubLink*/}
                {/*                  name={subOption.name}*/}
                {/*                  path={option.getPath() + subOption.getPath()}*/}
                {/*                  isActive={isActive}*/}
                {/*                  isLocked={!(index < 2)}*/}
                {/*                />*/}
                {/*              </Box>*/}
                {/*            </CustomLi>*/}
                {/*          );*/}
                {/*        }*/}
                {/*      )*/}
                {/*    }*/}
                {/*  </ul>*/}
                {/*}*/}
              </Box>
            );
          }
        )
      }
      <Box flexGrow={1}/>

      <Box>
        {
          Object.values(SUPPORT_LINKS).map((name, index) => {
            const option = sidebarSupportSetup[name];
            return (
              <Box key={name}>
                <MainLink
                  expanded={expanded}
                  icon={option.icon || ''} name={name} path={option.getPath()}
                  isWithActiveChild={pathname.startsWith(option.getPath())}
                  isActive={pathname.startsWith(option.getPath())}
                />
              </Box>
            );
          })
        }
      </Box>

      <Box borderTop={`1px solid ${theme.palette.grey['200']}`}>
        <Logout user={user} logoutHandler={logout.mutate} expanded={expanded}/>
      </Box>

    </ColumnFlexBox>
  );
};

export default Sidebar;